import { TextBadge } from "@hireart/component-library";
import PropTypes from "prop-types";

export const StatusBadge = ({ color, text }) => {
  return <TextBadge color={color}>{text}</TextBadge>;
};

StatusBadge.propTypes = {
  color: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};
